import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';
import { webhookEvents } from 'src/models/developer/webhook/_types';

interface WebhookEventFilterProps {
  value: string | undefined;
  setValue: (value: string) => void;
  label: string;
  valueOnly?: boolean;
}

export const WebhookEventFilter: React.FC<WebhookEventFilterProps> = ({
  value,
  setValue,
  label,
  valueOnly,
}) => {
  const selectedEvent = webhookEvents.find((event) => event.id === value);

  if (valueOnly) {
    return <>{selectedEvent ? selectedEvent.name : 'No Event Found'}</>;
  }

  return (
    <Autocomplete
      options={webhookEvents}
      getOptionLabel={(option) => option.name}
      value={webhookEvents.find((event) => event.id === value) || null}
      onChange={(_, newValue) => setValue(newValue?.id || '')}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Any" />
      )}
    />
  );
};
